import { useState, useContext, useCallback, useEffect } from "react";
import { useHistory } from "react-router-dom";
import scrollToTop from "../../../utilities/helpers/scrollToTop";
import { APPLICATION_ROUTES } from "../../../constants";
import { StoreContext } from "../../../contexts";
import { ACTIONS } from "../../../store";

const useLibraryFilter = () => {
  let history = useHistory();
  const { library } = useContext(StoreContext);
  let libraryUrl = new URL(location.href);
  let coloringPageToggle = libraryUrl.searchParams.get("coloring-pages") == "true" ? true : false;

  let projectedPage = location.pathname.includes(APPLICATION_ROUTES.LIBRARY_PROECTED);

  let myMaorPage = location.pathname.includes(APPLICATION_ROUTES.MY_MAOR_MAIN);

  const [keyword, setKeyword] = useState(libraryUrl.searchParams.get("keyword") ?? "");
  const [projectType, setProjectType] = useState("");
  const [order, setOrder] = useState(libraryUrl.searchParams.get("order") ?? "new");
  const [maorTypeValue, setMaorTypeValue] = useState(0);
  const [dailyRebbeTypeValue, setDailyRebbeTypeValue] = useState("");
  const [illuminateTypeValue, setIlluminateTypeValue] = useState("");
  const [tagsValue, setTagsValue] = useState([]);
  const [holidayId, setHolidayId] = useState(libraryUrl.searchParams.get("holiday") ?? 0);
  const [appliedFilterValues, setAppliedFiltersValues] = useState({});
  const [coloringPagesValue, setColoringPagesValue] = useState(coloringPageToggle);

  useEffect(() => {
    let currentUrl = new URL(window.location.href);
    let urlKeyword = currentUrl.searchParams.get("keyword") || "";
    let urlCategory = currentUrl.searchParams.get("category") || "";
    let urlCategoryLabel = currentUrl.searchParams.get("category-label") || "";
    let urlHoliday = currentUrl.searchParams.get("holiday") || "";
    let urlHolidayLabel = currentUrl.searchParams.get("holiday-label") || "";
    let urlColoring = currentUrl.searchParams.get("coloring-pages") === "true";

    let newFilters = {};
    if (urlKeyword) {
      newFilters["keyword"] = urlKeyword;
      setKeyword(urlKeyword);
    } else {
      setKeyword("");
    }
    if (urlCategory && urlCategoryLabel) {
      newFilters["category"] = urlCategoryLabel;
    }
    if (urlHoliday && urlHolidayLabel) {
      newFilters["holiday"] = urlHolidayLabel;
    }
    if (urlColoring) {
      newFilters["coloring-pages"] = "Coloring Pages";
    }

    setAppliedFiltersValues(newFilters);
  }, [history.location.search]);

  const removeColoringPageFilter = () => {
    setColoringPagesValue(false);
    appliedFilters.remove("coloring-pages");
  };

  const handleNavigationChange = (href) => {
    console.log("href", href);
    if (
      href.includes(projectedPage ? APPLICATION_ROUTES.MY_MAOR_LIBRARY_PROTECTED : APPLICATION_ROUTES.MY_MAOR_LIBRARY)
    ) {
      setProjectType("MyMaor");
      setMaorTypeValue(libraryUrl.searchParams.get("category") ?? "");
      setDailyRebbeTypeValue("");
      setIlluminateTypeValue("");
      tagsValue.length > 0 ? setKeyword(tagsValue[0]) : setKeyword(libraryUrl.searchParams.get("keyword") ?? "");
    } else if (
      href.includes(
        projectedPage
          ? APPLICATION_ROUTES.DAILY_REBBE_VIDEO_LIBRARY_PROTECTED
          : APPLICATION_ROUTES.DAILY_REBBE_VIDEO_LIBRARY
      )
    ) {
      setMaorTypeValue("");
      setDailyRebbeTypeValue(libraryUrl.searchParams.get("category") ?? "");
      setIlluminateTypeValue("");
      setProjectType("DailyRebbeVideo");
      tagsValue.length > 0 ? setKeyword(tagsValue[0]) : setKeyword(libraryUrl.searchParams.get("keyword") ?? "");
    } else if (
      href.includes(
        projectedPage ? APPLICATION_ROUTES.ILLUMINATE_LIBRARY_PROTECTED : APPLICATION_ROUTES.ILLUMINATE_LIBRARY
      )
    ) {
      setMaorTypeValue("");
      setIlluminateTypeValue(libraryUrl.searchParams.get("category") ?? "");
      setDailyRebbeTypeValue("");
      setProjectType("Illuminate");
      tagsValue.length > 0 ? setKeyword(tagsValue[0]) : setKeyword(libraryUrl.searchParams.get("keyword") ?? "");
    } else {
      setProjectType("");
      setMaorTypeValue("");
      setDailyRebbeTypeValue("");
      setIlluminateTypeValue("");
      appliedFilters.remove("category");
      tagsValue.length > 0 ? setKeyword(tagsValue[0]) : setKeyword(libraryUrl.searchParams.get("keyword") ?? "");
    }
  };

  const onNavigationChange = (event) => {
    handleNavigationChange(event.target.href);
  };

  let search = {
    onChange: (value) => {
      console.log("search #2", search.value);

      let project = "all";

      if (
        libraryUrl.href.includes(APPLICATION_ROUTES.MY_MAOR_LIBRARY) ||
        libraryUrl.href.includes(APPLICATION_ROUTES.MY_MAOR_MAIN)
      ) {
        project = "mymaor";
      } else if (
        libraryUrl.href.includes(APPLICATION_ROUTES.DAILY_REBBE_VIDEO_LIBRARY) ||
        libraryUrl.href.includes(APPLICATION_ROUTES.DAILY_REBBE_VIDEO_MAIN)
      ) {
        project = "daily-rebbe";
      } else if (
        libraryUrl.href.includes(APPLICATION_ROUTES.ILLUMINATE_LIBRARY) ||
        libraryUrl.href.includes(APPLICATION_ROUTES.ILLUMINATE)
      ) {
        project = "illuminate";
      } else {
        project = "all";
      }

      if (project == "all") {
        library.saveSearchResult({ project: project, search: value });
      }

      setKeyword(value);
      appliedFilters.add("keyword", value, {
        paramValue: value,
      });
      removeColoringPageFilter();
    },
    value: keyword,
  };

  let sorting = {
    onChange: ({ target: { value } }) => {
      setOrder(value);

      libraryUrl.searchParams.set("order", value);
      history.push({
        search: libraryUrl.search,
      });
    },
    value: order,
  };

  let holiday = {
    onChange: ({ target: { dataset, value } }) => {
      setHolidayId(value);
      history.push(APPLICATION_ROUTES.LIBRARY);
      appliedFilters.add("holiday", dataset.filterlabel, {
        paramValue: value,
      });
      removeColoringPageFilter();
    },
    value: holidayId,
  };

  let searching = {
    options: library.searchingOptions,
    onSearch: useCallback((query) => {
      library[`getSearchingOptions`](query);
    }),
    isLoading: library[`isLoading${ACTIONS.LIBRARY.SEARCHING_OPTIONS}`],
    error: library[`error${ACTIONS.LIBRARY.SEARCHING_OPTIONS}`],
  };

  let maorType = {
    onChange: ({ target: { dataset, value } }) => {
      console.log("TG", dataset);
      setMaorTypeValue(value);
      // Reset Search
      setDailyRebbeTypeValue("DailyRebbeVideo");
      setIlluminateTypeValue("Illuminate");
      setProjectType("MyMaor");
      // setKeyword("");
      setTagsValue([]);
      // setOrder("");

      history.push({
        pathname: projectedPage ? APPLICATION_ROUTES.MY_MAOR_LIBRARY_PROTECTED : APPLICATION_ROUTES.MY_MAOR_LIBRARY,
      });
      appliedFilters.add("category", dataset.filterlabel, {
        paramValue: value,
      });

      removeColoringPageFilter();
    },
    value: maorTypeValue,
  };

  let dailyRebbeType = {
    onChange: ({ target: { dataset, value } }) => {
      setDailyRebbeTypeValue(value);
      // Reset Search
      setMaorTypeValue("");
      setIlluminateTypeValue("");
      setProjectType("DailyRebbeVideo");
      // setKeyword("");
      setTagsValue([]);

      // setOrder("");
      history.push({
        pathname: projectedPage
          ? APPLICATION_ROUTES.DAILY_REBBE_VIDEO_LIBRARY_PROTECTED
          : APPLICATION_ROUTES.DAILY_REBBE_VIDEO_LIBRARY,
      });
      appliedFilters.add("category", dataset.filterlabel, {
        paramValue: value,
      });

      removeColoringPageFilter();
    },
    value: dailyRebbeTypeValue,
  };

  let illuminateType = {
    onChange: ({ target: { dataset, value } }) => {
      setIlluminateTypeValue(value);
      // Reset Search
      setMaorTypeValue("");
      setDailyRebbeTypeValue("");
      setProjectType("Illuminate");
      // setKeyword("");
      setTagsValue([]);
      // setOrder("");
      history.push({
        pathname: projectedPage
          ? APPLICATION_ROUTES.ILLUMINATE_LIBRARY_PROTECTED
          : APPLICATION_ROUTES.ILLUMINATE_LIBRARY,
      });

      appliedFilters.add("category", dataset.filterlabel, {
        paramValue: value,
      });

      removeColoringPageFilter();
    },
    value: illuminateTypeValue,
  };

  let tag = {
    onChange: ({ target: { value } }) => {
      let updatedTags = tagsValue.map((item) => item);
      if (updatedTags.includes(value)) {
        updatedTags = updatedTags.filter((item) => item !== value);
        setKeyword("");
        appliedFilters.remove("keyword");
      } else {
        setKeyword(value);
        updatedTags = [value];

        appliedFilters.add("keyword", value, {
          paramValue: value,
        });
        document.querySelector(".rbt-input-main").value = value;
      }
      setTagsValue(updatedTags);
      removeColoringPageFilter();
      scrollToTop();
    },
    value: tagsValue,
  };

  const coloringPages = {
    onChange: () => {
      if (!coloringPagesValue) {
        appliedFilters.add("coloring-pages", "Coloring Pages", {
          paramValue: true,
        });
      } else {
        appliedFilters.remove("coloring-pages");
      }
      setColoringPagesValue(!coloringPagesValue);
    },
    value: coloringPagesValue,
  };

  let appliedFilters = {
    data: appliedFilterValues,
    clearAll: () => {
      setKeyword("");
      setTagsValue([]);
      appliedFilters.remove("keyword");
      document.querySelector("#hiddenAsyncInputClear").click();

      setDailyRebbeTypeValue("");
      setIlluminateTypeValue("");
      setMaorTypeValue("");
      setProjectType("");
      history.push({
        pathname: projectedPage
          ? APPLICATION_ROUTES.MY_MAOR_LIBRARY_PROTECTED
          : myMaorPage
          ? APPLICATION_ROUTES.MY_MAOR_MAIN
          : APPLICATION_ROUTES.MY_MAOR_LIBRARY,
      });
      appliedFilters.remove("category");

      setHolidayId("");
      appliedFilters.remove("holiday");

      setColoringPagesValue(false);
      appliedFilters.remove("coloring-pages");
    },
    onClear: (type) => {
      switch (type) {
        case "keyword":
          setKeyword("");
          setTagsValue([]);
          appliedFilters.remove("keyword");
          document.querySelector("#hiddenAsyncInputClear").click();
          break;

        case "category":
          setDailyRebbeTypeValue("");
          setIlluminateTypeValue("");
          setMaorTypeValue("");
          setProjectType("");
          history.push({
            pathname: projectedPage ? APPLICATION_ROUTES.LIBRARY_PROECTED : APPLICATION_ROUTES.LIBRARY,
          });
          appliedFilters.remove("category");
          break;

        case "holiday":
          setHolidayId("");
          appliedFilters.remove("holiday");
          break;

        case "coloring-pages":
          setColoringPagesValue(false);
          appliedFilters.remove("coloring-pages");
          break;
      }
    },
    add: (key, value, data = {}) => {
      let filters = { ...appliedFilterValues };
      filters[key] = value;
      setAppliedFiltersValues(filters);

      let currentUrl = new URL(window.location.href);
      const paramVal = data.paramValue !== undefined ? data.paramValue : value;
      currentUrl.searchParams.set(key, paramVal);
      // Special Label case
      if (key == "category" || key == "holiday") {
        currentUrl.searchParams.set(`${key}-label`, value);
      }

      history.push({
        search: currentUrl.search,
      });
    },
    remove: (key) => {
      let filters = { ...appliedFilterValues };
      delete filters[key];
      setAppliedFiltersValues(filters);

      let currentUrl = new URL(window.location.href);
      currentUrl.searchParams.delete(key);
      // Special Label case
      if (key == "category" || key == "holiday") {
        currentUrl.searchParams.delete(`${key}-label`);
      }
      history.push({
        search: currentUrl.search,
      });
    },
  };

  let filterData = {
    categories: {
      onLoad: useCallback(() => {
        library[`getCategories`]();
      }, []),
      data: library.filterData.categories.data,
      isLoading: library.filterData.categories.isLoading,
      isError: library.filterData.categories.isError,
    },
    tags: {
      onLoad: useCallback(() => {
        library[`getTags`]();
      }, []),
      data: library.filterData.tags.data,
      isLoading: library.filterData.tags.isLoading,
      isError: library.filterData.tags.isError,
    },
    holidaysToday: {
      onLoad: useCallback(() => {
        library[`getTodayHolidays`]();
      }, []),
      data: library.filterData.holidays.data,
      isLoading: library.filterData.holidays.isLoading,
      isError: library.filterData.holidays.isError,
    },
  };

  return {
    search,
    projectType,
    setProjectType,
    handleNavigationChange,
    onNavigationChange,
    sorting,
    maorType,
    dailyRebbeType,
    illuminateType,
    coloringPages,
    tag,
    filterData,
    holiday,
    appliedFilters,
    searching,
  };
};

export default useLibraryFilter;
